const DiscoverySettings = {
  SHOW_CHALLENGES: "showChallenges",
  COST_OF_STATUS_QUO_CHART_MODE: "costOfStatusQuoChartMode"
} as const;

export default DiscoverySettings;
